// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rcs-inner-handle{background-color:#8e8e8e !important}.rcs-custom-scroll{width:100%}.rcs-inner-container{padding:0 15px}", ""]);
// Exports
module.exports = exports;
